import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';

export enum IVSteps {
  select = 'select',
  upload = 'upload',
  selfie = 'selfie',
}

export type StepperEventParams = {
  steps: number;
  currentNumberStep: number;
  currentStep: IVSteps;
};

type Actions = {
  setSteps: (steps: number) => void;
  setCurrentStep: (currentStep: IVSteps) => void;
  resetIVProcess: () => void;
};

const initialState: StepperEventParams = {
  steps: 0,
  currentNumberStep: 0,
  currentStep: IVSteps.select,
};

export const useStepperStore = create<StepperEventParams & Actions>()(
  immer(set => ({
    ...initialState,
    setSteps: steps =>
      set(state => {
        state.steps = steps;
      }),
    setCurrentStep: currentStep =>
      set(state => {
        state.currentStep = currentStep;
        if (state.currentStep === IVSteps.selfie) {
          state.currentNumberStep = state.steps;
        }
        if (state.currentStep === IVSteps.upload) {
          state.currentNumberStep++;
        }
      }),
    resetIVProcess: () => initialState,
  })),
);
